import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  downloadFrom: {
    id: 'get_it_on',
  },
  googlePlay: {
    id: 'google_play',
  },
});
